import { useNotificationStore } from '@/store/notification'
import { AnimatePresence } from 'framer-motion'
import { Notification } from './Notification'

export const Notifications = () => {
  const notification = useNotificationStore()
  return (
    <section className="pointer-events-none fixed inset-0 z-50 flex flex-col items-end gap-y-4 p-4">
      <AnimatePresence>
        {notification.notifcations.map(({ id, message, title, type }) => (
          <Notification
            key={id}
            message={message}
            title={title}
            type={type}
            handleClose={() => notification.closeNotifcation(id)}
          />
        ))}
      </AnimatePresence>
    </section>
  )
}
